export default __webpack_public_path__ + "static/media/login-bg.8617f851.jpg";